var ARSearch = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"search-input",attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleEscKey($event)}}},[_c('ar-input',{ref:"input",staticClass:"input",attrs:{"value":_vm.realValue,"placeholder":_vm.placeholder,"auto-focus":_vm.autoFocus,"enable-clear":_vm.enableClear,"icon-name":"search","autocomplete":"search","data-test-id":"search-input","align":_vm.align,"direction":_vm.direction},on:{"enter":_vm.handleEnterPress,"blur":_vm.handleSearchBlur,"input":_vm.handleInputChange}})],1)},
staticRenderFns: [],
  name: 'Search',

  props: {
    placeholder: {
      type: String,
      default: '',
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    enableClear: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) =>
        ['left', 'right', 'center'].indexOf(value) !== -1,
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
  },

  data() {
    return {
      /**
       * Allows you to use ar-search without two-way binding by v-model, otherwise text inside ar-input
       * will disappear once it's blurred if you use value as ar-input's value
       */
      realValue: null,
    };
  },

  watch: {
    value: {
      handler: function (val) {
        this.realValue = val;
      },
      immediate: true,
    },
  },

  methods: {
    handleEscKey(e) {
      this.$emit('escape', e);
    },
    focus() {
      this.$refs.input.focus();
    },
    handleEnterPress(e) {
      this.$emit('enter', e);
    },
    handleSearchBlur(e) {
      this.$emit('blur', e);
    },
    handleInputChange(val) {
      this.realValue = val;
      this.$emit('input', val);
      if (val === '') {
        this.$emit('clear', '');
      }
    }
  },
};

export default ARSearch;
